// Greek translations
const translations = {
  // Navigation
  dashboard: "Πίνακας Ελέγχου",
  excavators: "Μηχανήματα",
  reports: "Αναφορές",
  users: "Χρήστες",
  profile: "Προφίλ",
  logout: "Αποσύνδεση",
  login: "Σύνδεση",
  register: "Εγγραφή",
  management: "Διαχείριση",
  analytics: "Αναλύσεις",
  hello: "Γεια σας",
  maintenanceReportSystem: "Σύστημα Αναφορών Συντήρησης",
  changeLanguage: "Αλλαγή γλώσσας",

  // Dashboard Specific
  // Verwalten Sie Ihre Baumaschinen und Wartungsberichte effizient 
  dashboardSubtitle: " Διαχειριστείτε τις μηχανές και τις αναφορές συντήρησης σας αποτελεσματικά",
  setLastMaintenanceDate: " Ορίστε την ημερομηνία τελευταίας συντήρησης",
  todaysDate: " Σημερινή ημερομηνία",
  Saturday: " Σάββατο", // Already Greek
  Sunday: " Κυριακή", // Already Greek
  Monday: " Δευτέρα", // Already Greek
  Tuesday: " Τρίτη", // Already Greek
  Wednesday: " Τετάρτη", // Already Greek
  Thursday: " Πέμπτη", // Already Greek
  Friday: " Παρασκευή", // Already Greek
  notesAndObservations: " Σημειώσεις και Παρατηρήσεις",
  Dashboard: " Πίνακας Ελέγχου", // Capitalized version
  welcomeBack: " Καλώς ήρθατε πίσω",
  selectLanguage: " Επιλογή Γλώσσας",
  createNewReport: " Δημιουργία Νέας Αναφοράς",
  fromLastMonth: " Από τον τελευταίο μήνα",
  requiresAttention: " Απαιτεί προσοχή",
  lastSixMonths: " Από τους τελευταίους 6 μήνες",
  noRecentReports: " Δεν υπάρχουν πρόσφατες αναφορές",
  noPendingReports: " Δεν υπάρχουν εκκρεμείς αναφορές",
  inspection: " Επιθεώρηση",
  viewDetails: " Προβολή Λεπτομερειών",
  personnel: " Προσωπικό",
  entryDetails: " Λεπτομέρειες Καταχώρησης",
  viewReports: " Προβολή Αναφορών",
  viewAllUsers: " Προβολή Όλων των Χρηστών",
  items: " Στοιχεία",
  refreshing: " Ανανέωση...",
  reportStatus: " Κατάσταση Αναφοράς",
  allSigned: " Όλες οι αναφορές είναι υπογεγραμμένες",
  excellent: " Άριστα",
  active: " Ενεργό",
  signedby: " Υπογράφηκε από",
  excavatorHealth: " Υγεία Μηχανήματος",
  needsAttention: " Χρειάζεται Προσοχή",
  healthScore: " Βαθμολογία Υγείας",
  noExcavatorData: " Δεν υπάρχουν διαθέσιμα δεδομένα μηχανήματος",
  noOperatorData: " Δεν υπάρχουν διαθέσιμα δεδομένα χειριστή",
  byReportCount: " Ανά Αριθμό Αναφορών",
  topOperators: " Κορυφαίοι Χειριστές",
  topExcavators: " Κορυφαία Μηχανήματα",
  refresh: " Ανανέωση",
  searchExcavators: " Αναζήτηση Μηχανημάτων",
  maintenanceReport: " Αναφορά Συντήρησης",
  created: " Δημιουργήθηκε",
  createdAt: " Δημιουργήθηκε στις",
  signReport: " Υπογραφή Αναφοράς",
  signReportDescription: " Bitte unterschreiben Sie den Bericht, um ihn zu genehmigen. Ihre Unterschrift wird zur Genehmigung des Berichts verwendet.",
  signatureArea: " Περιοχή Υπογραφής",
  signAndApprove: " Υπογραφή και Έγκριση",
  signingAs: " Υπογράφετε ως",
  useProfileSignature: " Χρήση Υπογραφής Προφίλ",
  "Invalid Date": " Άκυρη Ημερομηνία",
  recentBetriebstagebuch: " Πρόσφατες Καταχωρήσεις Ημερολογίου Λειτουργίας",
  details: " Λεπτομέρειες",
  equipmentAndPersonnel: " Εξοπλισμός και Προσωπικό",
  Berichtsdetails: " Λεπτομέρειες Αναφοράς",
  lastLogin: " Τελευταία Σύνδεση",
  searchByNameEmailRole: " Αναζήτηση με Όνομα, Email ή Ρόλο",
  adminFullAccess: " Διαχειριστής - Πλήρης Πρόσβαση",
  managerAccess: " Υπεύθυνος - Περιορισμένη Πρόσβαση",
  operatorAccess: " Χειριστής - Περιορισμένη Πρόσβαση",
  newPasswordLeaveBlank: " Νέος Κωδικός (αφήστε κενό για διατήρηση του τρέχοντος)",
  enterFullName: " Εισαγωγή Πλήρους Ονόματος",
  noReportsFound: " Δεν Βρέθηκαν Αναφορές",
  noReportsCreatedYet: " Δεν έχουν δημιουργηθεί ακόμη αναφορές",
  next: " Επόμενο",
  excavatorList: " Λίστα Μηχανημάτων",
  approvalConfirmation: " Είστε βέβαιοι ότι θέλετε να εγκρίνετε αυτήν την αναφορά;",
  clearPad: " Καθαρισμός Υπογραφής",
  approve: " Έγκριση",
  setOperational: " Σήμανση ως Λειτουργικό",
  assignOperator: " Ανάθεση Χειριστή",
  scheduleMaintenance: " Προγραμματισμός Συντήρησης",
  betriebstagebuchQuickView: " Γρήγορη Προβολή Ημερολογίου Λειτουργίας",
  entryId: " ID Καταχώρησης",
  yourSignature: " Η Υπογραφή σας",
  security: " Ασφάλεια",
  signatureDescription: " Παρακαλώ προσθέστε την υπογραφή σας για να εγκρίνετε αναφορές.",
  signatureTips: " Συμβουλές Υπογραφής: Χρησιμοποιήστε το στυλό για να σχεδιάσετε την υπογραφή σας. Κάντε κλικ στο 'Αποθήκευση Υπογραφής' για αποθήκευση.",
  signatureTip1: " Προσθήκη Υπογραφής: Χρησιμοποιήστε το στυλό για να σχεδιάσετε την υπογραφή σας.",
  signatureTip2: " Κάντε κλικ στο 'Αποθήκευση Υπογραφής' για να αποθηκεύσετε την υπογραφή σας.",
  signatureTip3: " Κάντε κλικ στο 'Καθαρισμός Υπογραφής' για να αφαιρέσετε την υπογραφή σας.",
  signatureTip4: " Κάντε κλικ στο 'Αποθήκευση Υπογραφής' για να αποθηκεύσετε την υπογραφή σας.",
  currentSignature: " Τρέχουσα Υπογραφή",
  emailCannotBeChanged: " Η διεύθυνση email δεν μπορεί να αλλάξει",
  fullName: " Πλήρες Όνομα",
  memberSince: " Μέλος από",
  systemDescription: " Das Wartungsberichtsystem ist eine webbasierte Anwendung...",
  registerToJoinDescription: " Registrieren Sie sich, um dem Wartungsberichtsystem beizutreten...",
  registerToJoin: " Registrieren Sie sich, um dem Wartungsberichtsystem beizutreten",
  forgotPassword: " Ξεχάσατε τον κωδικό;",
  address: " Herzbergstraße 19-21, 10365 Berlin, Deutschland",
  contactUs: " Επικοινωνήστε μαζί μας",
  termsOfService: " Όροι Παροχής Υπηρεσιών",
  privacyPolicy: " Πολιτική Απορρήτου",
  specialChecks: " Ειδικοί Έλεγχοι",
  addSpecialCheck: " Προσθήκη Ειδικού Ελέγχου",
  "reports.totalReports": " Συνολικές Αναφορές",
  "reports.statistics": " Στατιστικά Αναφορών",
  "reports.thisMonth": " Μηνιαίες Αναφορές",
  "reports.pending": " Εκκρεμείς Αναφορές",
  "reports.completed": " Ολοκληρωμένες Αναφορές",
  noGeneralNotesProvided: " Δεν παρέχονται γενικές σημειώσεις",
  close: " Κλείσιμο",
  serviceDate: " Ημερομηνία Αναφοράς",
  size: " Μέγεθος",
  machineType: " Τύπος Μηχανήματος",
  Wheeled: " Τροχοφόρο",
  viewFullDetails: " Προβολή Πλήρων Λεπτομερειών",
  downloadPdf: " Λήψη PDF",

  // Excavator table headers
  manufacturer: "Κατασκευαστής",
  model: "Μοντέλο",
  serialNumber: "Σειριακός Αριθμός",
  year: "Έτος",
  status: "Κατάσταση",
  lastMaintenance: "Τελευταία Συντήρηση",
  actions: "Ενέργειες",

  // Report table headers
  reportId: "Αριθμός Αναφοράς",
  excavator: "Μηχάνημα",
  type: "Τύπος",
  date: "Ημερομηνία",
  technician: "Χειριστής", // Updated from "Τεχνικός" to "Χειριστής" (Operator)
  report: "Αναφορά",
  machine: "Μηχάνημα",

  // Actions
  view: "Προβολή",
  edit: "Επεξεργασία",
  delete: "Διαγραφή",
  add: "Προσθήκη",
  addExcavator: "Προσθήκη Μηχανήματος",
  addReport: "Προσθήκη Αναφοράς",

  // Status options
  operational: "Λειτουργικό",
  maintenance: "Σε Συντήρηση",
  repair: "Σε Επισκευή",
  outOfService: "Εκτός Λειτουργίας",
  signed: "Υπογεγραμμένο",
  unsigned: "Μη υπογεγραμμένο",
  approved: "Εγκεκριμένο",
  pendingApproval: "Εκκρεμεί έγκριση",
  completed: "Ολοκληρωμένο",

  // Form labels
  save: "Αποθήκευση",
  cancel: "Ακύρωση",
  uploadImage: "Μεταφόρτωση Εικόνας",

  // Other common text
  confirmDelete: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το στοιχείο;",
  noDataAvailable: "Δεν υπάρχουν διαθέσιμα δεδομένα",
  loading: "Φόρτωση...",
  error: "Σφάλμα",
  success: "Επιτυχία",

  // 404 Page
  pageNotFound: "Η Σελίδα Δεν Βρέθηκε",
  pageNotFoundMessage:
    "Η σελίδα που αναζητάτε ενδέχεται να έχει αφαιρεθεί, να έχει αλλάξει όνομα ή να μην είναι προσωρινά διαθέσιμη.",
  goToDashboard: "Μετάβαση στον Πίνακα Ελέγχου",
  goBack: "Επιστροφή",

  // Footer
  version: "Έκδοση",
  footerDescription:
    "Το σύστημα διαχείρισης συντήρησης μηχανημάτων για επιχειρήσεις κατασκευών και εξόρυξης.",
  navigation: "Πλοήγηση",
  resources: "Πόροι",
  statistics: "Στατιστικά",
  help: "Βοήθεια",
  documentation: "Τεκμηρίωση",
  support: "Υποστήριξη",
  contact: "Επικοινωνία",
  followUs: "Ακολουθήστε μας",
  allRightsReserved: "Με επιφύλαξη παντός δικαιώματος",
  terms: "Όροι χρήσης",
  privacy: "Ιδιωτικότητα",
  cookies: "Cookies",

  // User Management
  userManagement: "Διαχείριση Χρηστών",
  createUser: "Δημιουργία Χρήστη",
  editUser: "Επεξεργασία Χρήστη",
  deleteUser: "Διαγραφή Χρήστη",
  name: "Όνομα",
  email: "Email",
  role: "Ρόλος",
  password: "Κωδικός",
  confirmPassword: "Επιβεβαίωση Κωδικού",
  administrator: "Διαχειριστής",
  manager: "Υπεύθυνος",
  operator: "Χειριστής",

  // Profile page
  changePassword: "Αλλαγή Κωδικού",
  currentPassword: "Τρέχων Κωδικός",
  newPassword: "Νέος Κωδικός",
  updatePassword: "Ενημέρωση Κωδικού",
  userProfile: "Προφίλ Χρήστη",
  personalDetails: "Προσωπικά Στοιχεία",
  department: "Τμήμα",
  phoneNumber: "Αριθμός Τηλεφώνου",
  signature: "Υπογραφή",
  saveChanges: "Αποθήκευση Αλλαγών",
  uploadProfileImage: "Μεταφόρτωση Εικόνας Προφίλ",

  // Login/Register
  loginToAccess: "Συνδεθείτε για πρόσβαση στο σύστημα",
  createAccount: "Δημιουργία Λογαριασμού",
  alreadyHaveAccount: "Έχετε ήδη λογαριασμό;",
  dontHaveAccount: "Δεν έχετε λογαριασμό;",
  enterEmail: "Εισάγετε το email σας",
  enterPassword: "Εισάγετε τον κωδικό σας",
  enterName: "Εισάγετε το όνομά σας",
  confirmYourPassword: "Επιβεβαιώστε τον κωδικό σας",
  or: "Ή",
  emailRequired: "Το email είναι υποχρεωτικό",
  pleaseEnterValidEmail: "Παρακαλώ εισάγετε ένα έγκυρο email",
  passwordRequired: "Ο κωδικός είναι υποχρεωτικός",
  passwordMinLength: "Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες",
  loggingIn: "Σύνδεση...",

  // Dashboard
  welcome: "Καλώς ήρθατε πίσω",
  viewProfile: "Προβολή Προφίλ",
  quickActions: "Γρήγορες Ενέργειες",
  recentActivity: "Πρόσφατη Δραστηριότητα",
  maintenanceStatus: "Κατάσταση Συντήρησης",
  monthlyReports: "Μηνιαίες Αναφορές",
  createReport: "Δημιουργία Αναφοράς",
  pendingWork: "Εκκρεμείς Εργασίες",
  viewReportStatistics: "Προβολή Στατιστικών Αναφορών",
  totalExcavators: "Συνολικά Μηχανήματα",
  activeExcavators: "Ενεργά Μηχανήματα",
  totalReports: "Συνολικές Αναφορές",
  pendingReports: "Εκκρεμείς Αναφορές",
  loadingDashboard: "Φόρτωση δεδομένων πίνακα ελέγχου...",
  failedToLoadDashboard:
    "Αποτυχία φόρτωσης δεδομένων πίνακα ελέγχου. Παρακαλώ δοκιμάστε ξανά.",
  viewAll: "Προβολή Όλων",

  // Filter and Search
  filter: "Φίλτρο",
  search: "Αναζήτηση",
  searchPlaceholder:
    "Αναζήτηση με βάση μοντέλο, κατασκευαστή, σειριακό αριθμό...",
  clear: "Καθαρισμός",
  all: "Όλα",
  upToDate: "Ενημερωμένο",
  maintenanceDue: "Εκκρεμεί Συντήρηση",
  overdue: "Καθυστερημένο",
  resetFilters: "Επαναφορά Φίλτρων",
  applyFilters: "Εφαρμογή Φίλτρων",
  never: "Ποτέ",
  apply: "Εφαρμογή",
  reset: "Επαναφορά",

  // Report Detail Page
  loadingReport: "Φόρτωση αναφοράς...",
  failedToLoadReport: "Αποτυχία φόρτωσης αναφοράς",
  errorDownloadingPDF: "Σφάλμα κατά τη λήψη του PDF",
  signatureRequired: "Απαιτείται υπογραφή",
  nameRequired: "Απαιτείται όνομα",
  reviewerName: "Όνομα αξιολογητή",
  clearSignature: "Καθαρισμός υπογραφής",
  saveSignature: "Αποθήκευση υπογραφής",
  enterYourName: "Εισάγετε το όνομά σας",
  onlyManagersCanApprove: "Μόνο οι διαχειριστές μπορούν να εγκρίνουν αναφορές",
  downloading: "Λήψη...",
  downloadPDF: "Λήψη PDF",
  approveReport: "Έγκριση αναφοράς",
  editReport: "Επεξεργασία αναφοράς",
  maintenanceReportDetails: "Λεπτομέρειες αναφοράς συντήρησης",
  back: "Πίσω",
  reportNotFound: "Η αναφορά δεν βρέθηκε",
  reportNotFoundMessage: "Η αναφορά που ζητήθηκε δεν βρέθηκε",
  viewAllReports: "Προβολή όλων των αναφορών",
  approveMaintenanceReport: "Έγκριση αναφοράς συντήρησης",
  managerName: "Όνομα διαχειριστή",
  createdOn: "Δημιουργήθηκε στις",
  excavatorInformation: "Πληροφορίες μηχανήματος",
  unknown: "Άγνωστο",
  "n/a": "Δεν διευκρινίζεται",
  serviceInformation: "Πληροφορίες συντήρησης",
  serviceType: "Τύπος συντήρησης",
  equipmentHours: "Ώρες λειτουργίας",
  location: "Τοποθεσία",
  routine: "Τακτική",
  exterior: "Εξωτερικό",
  interior: "Εσωτερικό",
  engine: "Κινητήρας",
  cleaning: "Καθαρισμός",
  notes: "Σημειώσεις",
  checklist: "Λίστα ελέγχου",
  item: "Στοιχείο",
  additionalNotes: "Πρόσθετες σημειώσεις",
  noAdditionalNotesProvided: "Δεν παρέχονται πρόσθετες σημειώσεις",
  signatures: "Υπογραφές",
  technicianSignature: "Υπογραφή χειριστή", // Updated from "Υπογραφή τεχνικού" to "Υπογραφή χειριστή"
  noSignatureAvailable: "Δεν υπάρχει διαθέσιμη υπογραφή",
  signedBy: "Υπογράφηκε από",
  managerApproval: "Έγκριση διαχειριστή",
  approvedBy: "Εγκρίθηκε από",
  thisReportIsWaitingForYourApproval:
    "Αυτή η αναφορά περιμένει την έγκρισή σας",
  pendingManagerApproval: "Εκκρεμεί έγκριση διαχειριστή",
  signAndApproveNow: "Υπογράψτε και εγκρίνετε τώρα",
  processing: "Επεξεργασία...",
  sign: "Υπογραφή",
  noInspectionDataAvailableFor:
    "Δεν υπάρχουν διαθέσιμα δεδομένα επιθεώρησης για",
  notSpecified: "Δεν καθορίστηκε",
  tryAgain: "Προσπαθήστε ξανά",
  generalInformation: "Γενικές πληροφορίες",
  technicalDetails: "Τεχνικές λεπτομέρειες",
  maintenanceChecklist: "Λίστα ελέγχου συντήρησης",
  operatingHours: "Ώρες λειτουργίας",
  hours: "ώρες",
  maintenanceType: "Τύπος συντήρησης",
  reviewedBy: "Εξετάστηκε από",
  signedDate: "Ημερομηνία υπογραφής",
  hydraulic: "Υδραυλικό",
  routineMaintenance: "Τακτική συντήρηση",
  failedToApproveReport: "Αποτυχία έγκρισης αναφοράς",
  reportApprovedSuccessfully: "Η αναφορά εγκρίθηκε επιτυχώς",
  specialChecksSummary: "Σύνοψη ειδικών ελέγχων",

  // Create Report Page
  createMaintenanceReport: "Δημιουργία Αναφοράς Συντήρησης",
  selectExcavator: "Επιλογή Μηχανήματος",
  pleaseSelectExcavator: "Παρακαλώ επιλέξτε ένα μηχάνημα",
  reportDetails: "Λεπτομέρειες Αναφοράς",
  maintenanceDate: "Ημερομηνία Συντήρησης",
  nextMaintenanceDate: "Επόμενη Ημερομηνία Συντήρησης",
  technicianName: "Όνομα Χειριστή",
  inspectionChecklist: "Λίστα Ελέγχου Επιθεώρησης",
  exteriorChecks: "Εξωτερικοί Έλεγχοι",
  interiorChecks: "Εσωτερικοί Έλεγχοι",
  engineChecks: "Έλεγχοι Κινητήρα",
  hydraulicChecks: "Υδραυλικοί Έλεγχοι",
  notApplicable: "Δεν Ισχύει",
  notDone: "Δεν Πραγματοποιήθηκε",
  additionalComments: "Πρόσθετα Σχόλια",
  submitReport: "Υποβολή Αναφοράς",
  pleaseAddSignature: "Παρακαλώ προσθέστε την υπογραφή σας",
  pleaseSelectDate: "Παρακαλώ επιλέξτε ημερομηνία",
  reportSubmittedSuccessfully: "Η αναφορά υποβλήθηκε με επιτυχία",
  failedToSubmitReport: "Αποτυχία υποβολής αναφοράς",
  submitting: "Υποβολή...",

  // Chart labels
  chartReportsByMonth: "Αναφορές ανά Μήνα",
  chartNumberOfReports: "Αριθμός Αναφορών",
  itemsCompleted: " Ολοκληρωμένα Στοιχεία",
  completionStatus: " Κατάσταση Ολοκλήρωσης",
  checksCompleted: " Ολοκληρωμένοι Έλεγχοι",
  notesAdded: " Προστιθέμενες Σημειώσεις",

  // Report checklist items
  chassis: "Σασί",
  boom: "Βραχίονας",
  bucket: "Κάδος",
  hydraulics: "Υδραυλικά",
  mirrors: "Καθρέπτες",
  windows: "Παράθυρα",
  cameras: "Κάμερες",
  lights: "Φώτα",
  wipers: "Υαλοκαθαριστήρες",
  lubricationSystem: "Σύστημα Λίπανσης",
  seat: "Κάθισμα",
  electronics: "Ηλεκτρονικά",
  heating: "Θέρμανση",
  airConditioning: "Κλιματισμός",
  joystick: "Joystick",
  display: "Οθόνη",
  controls: "Χειριστήρια",
  parkingBrake: "Χειρόφρενο",
  engineOil: "Λάδι Κινητήρα",
  hydraulicOil: "Υδραυλικό Λάδι",
  coolant: "Ψυκτικό Υγρό",
  windshieldWasher: "Υγρό Υαλοκαθαριστήρων",
  transmissionOil: "Λάδι Μετάδοσης",
  fuelFilter: "Φίλτρο Καυσίμου",
  airFilter: "Φίλτρο Αέρα",
  washed: "Πλυμένο",
  windowsCleaned: "Καθαρισμένα Παράθυρα",
  mirrorsCleaned: "Καθαρισμένοι Καθρέπτες",
  interiorWindowsCleaned: "Καθαρισμένα Εσωτερικά Παράθυρα",
  interiorWiped: "Σκουπισμένο Εσωτερικό",
  interiorVacuumed: "Καθαρισμένο με Ηλεκτρική Σκούπα Εσωτερικό",
  fuelLevel: "Στάθμη Καυσίμου",
  startDate: "Ημερομηνία Έναρξης",
  endDate: "Ημερομηνία Λήξης",
  nextInspectionDate: "Επόμενη Ημερομηνία Επιθεώρησης",

  // Betriebstagebuch (Operating Journal)
  betriebstagebuch: " Ημερολόγιο Λειτουργίας",
  betriebstagebuchList: " Λίστα Ημερολογίων Λειτουργίας",
  createBetriebstagebuch: " Δημιουργία Καταχώρησης Ημερολογίου Λειτουργίας",
  editBetriebstagebuch: " Επεξεργασία Καταχώρησης Ημερολογίου Λειτουργίας",
  viewBetriebstagebuch: " Προβολή Καταχώρησης Ημερολογίου Λειτουργίας",
  betriebstagebuchDetails: " Λεπτομέρειες Ημερολογίου Λειτουργίας",
  conveyorChecks: " Έλεγχοι Μεταφορέα",
  conveyorName: " Όνομα Μεταφορέα",
  functional: " Λειτουργικός",
  notFunctional: " Μη Λειτουργικός",
  conveyorNotes: " Σημειώσεις για αυτόν τον μεταφορέα",
  generalNotes: " Γενικές Σημειώσεις",
  addConveyor: " Προσθήκη Μεταφορέα",
  removeConveyor: " Αφαίρεση",
  noConveyorsAdded: " Δεν έχουν προστεθεί ακόμη μεταφορείς",
  entryDate: " Ημερομηνία Καταχώρησης",
  createdBy: " Δημιουργήθηκε Από",
  creator: " Δημιουργός",
  reviewer: " Αξιολογητής",
  quickView: " Γρήγορη Προβολή",
  tryChangingFilters: " Δοκιμάστε να αλλάξετε τα φίλτρα",
  reviewerSignature: " Υπογραφή Αξιολογητή",
  creatorSignature: " Υπογραφή Δημιουργού",
  betriebstagebuchCreated: " Η καταχώρηση ημερολογίου λειτουργίας δημιουργήθηκε με επιτυχία",
  betriebstagebuchUpdated: " Η καταχώρηση ημερολογίου λειτουργίας ενημερώθηκε με επιτυχία",
  betriebstagebuchApproved: " Η καταχώρηση ημερολογίου λειτουργίας εγκρίθηκε με επιτυχία",
  betriebstagebuchDeleted: " Η καταχώρηση ημερολογίου λειτουργίας διαγράφηκε με επιτυχία",
  downloadBetriebstagebuchPDF: " Λήψη PDF",
  approveBetriebstagebuch: " Έγκριση Καταχώρησης",
  recyclingCenter: " Κέντρο Ανακύκλωσης",
  sortingMachine: " Μηχανή Διαλογής",
  allConveyorsMustBeNamed: " Όλοι οι μεταφορείς πρέπει να έχουν όνομα",
  errorSavingEntry: " Σφάλμα αποθήκευσης καταχώρησης",
  conveyorChecksSummary: " Zusammenfassung der Förderband-Prüfungen",
  noSpecialChecksRecorded: " Δεν καταγράφηκαν ειδικοί έλεγχοι",
  backToList: " Επιστροφή στη Λίστα",
  reviewedOn: " Ελέγχθηκε στις",
  rowsPerPage: " Γραμμές ανά σελίδα",
  of: " από",
  searchExcavatorsPlaceholder: " Αναζήτηση με βάση μοντέλο, κατασκευαστή, σειριακό αριθμό ή τύπο...",
  searchBy: " Αναζήτηση με",
  noMatchingResults: " Δεν βρέθηκαν αποτελέσματα",
  clearSearch: " Καθαρισμός Αναζήτησης",
  // Batch Betriebstagebuch creation
  batchGenerateBetriebstagebuch: " Μαζική Δημιουργία Ημερολογίων Λειτουργίας",
  createMultipleEntries: " Δημιουργία πολλαπλών καταχωρήσεων ταυτόχρονα",
  dateRange: " Εύρος Ημερομηνιών",
  addNewUser: " Προσθήκη Νέου Χρήστη",
  nextMaintenance: " Επόμενη Συντήρηση",
  daysInRange: " Ημέρες στο Εύρος",
  entriesToBeGenerated: " Καταχωρήσεις προς Δημιουργία",
  allEntriesWillHaveYourSignature: " Όλες οι καταχωρήσεις θα έχουν την υπογραφή σας",
  generateEntries: " Δημιουργία Καταχωρήσεων",
  generating: " Δημιουργία...",
  generatedEntries: " Δημιουργημένες Καταχωρήσεις",
  betriebstagebuchEntriesGenerated: " Οι καταχωρήσεις ημερολογίου λειτουργίας δημιουργήθηκαν με επιτυχία",
  errorGeneratingEntries: " Σφάλμα κατά τη δημιουργία των καταχωρήσεων ημερολογίου λειτουργίας",
  dayOfWeek: " Ημέρα της Εβδομάδας",
  pleaseSelectDateRange: " Παρακαλώ επιλέξτε εύρος ημερομηνιών",
  endDateMustBeAfterStartDate: " Η ημερομηνία λήξης πρέπει να είναι μετά την ημερομηνία έναρξης",
  onlyAdminsCanBatchGenerate: " Μόνο οι διαχειριστές μπορούν να δημιουργήσουν μαζικά ημερολόγια λειτουργίας",
  allConveyorsWillBeAddedToEachEntry: " Όλοι οι μεταφορείς θα προστεθούν σε κάθε καταχώρηση",
  weekendsAreExcluded: " Τα Σαββατοκύριακα (Σάββατο και Κυριακή) εξαιρούνται αυτόματα",
  preview: " Προεπισκόπηση",
  allSpecialChecksMustBeNamed: " Όλοι οι ειδικοί έλεγχοι πρέπει να έχουν όνομα",
  specialCheckNotes: " Σημειώσεις για αυτόν τον έλεγχο",
  checkName: " Όνομα Ελέγχου",
  notCompleted: " Δεν Ολοκληρώθηκε",

  // Conveyor Names (kept in German for consistency)
  AT: "AT",
  Steigband: "Steigband",
  Trommel: "Trommel",
  HeckBand: "HeckBand",
  SortierBand: "SortierBand",
  MagnetSortierHaus: "MagnetSortierHaus",
  MagnetHalle: "MagnetHalle",
  SeitenBand: "SeitenBand",
  Zuführband: "Zuführband",
  TrommelWindsichter: "TrommelWindsichter",
  SpeedBand: "SpeedBand",
  Airlift: "Airlift",
  Airwheel: "Airwheel",
  Ventilator: "Ventilator",

  // Machine Overview/Details
  overview: " Επισκόπηση",
  description: " Περιγραφή",
  daysUntilDue: " Ημέρες μέχρι την προθεσμία",
  days: " Ημέρες",
  upcomingMaintenances: " Επερχόμενες Συντηρήσεις",
  updateHours: " Ενημέρωση Ωρών",
  updateOperatingHours: " Ενημέρωση Ωρών Λειτουργίας",
  featureComingSoon: " Η λειτουργία έρχεται σύντομα",
  uvvStatus: " Κατάσταση UVV",
  nextInspection: " Επόμενη Επιθεώρηση",
  noDescription: " Δεν υπάρχει διαθέσιμη περιγραφή",
  noNotes: " Δεν υπάρχουν διαθέσιμες σημειώσεις",
  noData: " Δεν υπάρχουν διαθέσιμα δεδομένα",
  gallery: " Συλλογή",
  attachments: " Συνημμένα",
  comments: " Σχόλια",
  relatedEquipment: " Σχετικός Εξοπλισμός",
  select: " Επιλογή",
  assign: " Ανάθεση",
  schedule: " Προγραμματισμός",

  // Bulk sign errors
  reportsAvailable: " διαθέσιμες αναφορές",
  bulkSignErrorTitle: " Σφάλμα Μαζικής Υπογραφής",
  currentUserDataMissingError: " Λείπουν δεδομένα χρήστη για τη μαζική υπογραφή.",

  // Missing placeholders and fallback strings
  appName: "FleetPilot",
  shiftStartPlaceholder: "π.χ. Πρωινή βάρδια, 06:00",
  shiftEndPlaceholder: "π.χ. Νυχτερινή βάρδια, 14:00",
  weatherPlaceholder: "π.χ. Ηλιόλουστο, ελαφρύς άνεμος",
  temperaturePlaceholder: "π.χ. 15",
  fuelLevelPlaceholder: "π.χ. 75%",
  foreignMaterialControl: "Έλεγχος Ιδίων, Ξένων και Παραδόσεων",
  noIncidents: "Κανένα περιστατικό",
  fetchingWeatherData: "Φόρτωση δεδομένων καιρού...",
  sunny: "Ηλιόλουστο",

  // Additional missing translations from form validations and operations
  signatureCannotBeEmpty: "Η υπογραφή δεν μπορεί να είναι κενή",
  noProfileSignatureAvailable: "Δεν υπάρχει διαθέσιμη υπογραφή προφίλ",
  managersOnlyCanCreateBTB: "Μόνο οι διευθυντές μπορούν να δημιουργήσουν καταχωρήσεις ημερολογίου",
  pleaseCorrectFormErrors: "Παρακαλώ διορθώστε τα σφάλματα της φόρμας",
  errorFetchingEntry: "Σφάλμα κατά την ανάκτηση της καταχώρησης",
  loadingEntry: "Φόρτωση καταχώρησης...",
  accessDenied: "Η πρόσβαση απορρίφθηκε",
  saving: "Αποθήκευση...",
  saved: "Αποθηκεύτηκε",
  updateEntry: "Ενημέρωση καταχώρησης",
  saveEntry: "Αποθήκευση καταχώρησης",
  entryUpdatedSuccess: "Η καταχώρηση ενημερώθηκε επιτυχώς",
  entryCreatedSuccess: "Η καταχώρηση δημιουργήθηκε επιτυχώς",
  general: "Γενικά",
  conveyorNameRequired: "Το όνομα του μεταφορέα είναι υποχρεωτικό",
  checkNameRequired: "Το όνομα του ελέγχου είναι υποχρεωτικό",
  dateIsRequired: "Η ημερομηνία είναι υποχρεωτική",
  signatureIsRequired: "Η υπογραφή είναι υποχρεωτική",

  // User Management missing translations
  errorFetchingUsers: "Σφάλμα κατά την ανάκτηση χρηστών",
  nameIsRequired: "Το όνομα είναι υποχρεωτικό",
  emailIsRequired: "Το email είναι υποχρεωτικό",
  invalidEmailFormat: "Μη έγκυρη μορφή email",
  passwordIsRequiredForNewUser: "Ο κωδικός είναι υποχρεωτικός για νέους χρήστες",
  userCreatedSuccessfully: "Ο χρήστης δημιουργήθηκε επιτυχώς",
  userUpdatedSuccessfully: "Ο χρήστης ενημερώθηκε επιτυχώς",
  errorSavingUser: "Σφάλμα κατά την αποθήκευση χρήστη",
  userDeletedSuccessfully: "Ο χρήστης διαγράφηκε επιτυχώς",
  errorDeletingUser: "Σφάλμα κατά τη διαγραφή χρήστη",
  manageUsers: "Διαχείριση χρηστών",
  searchUsers: "Αναζήτηση χρηστών",
  allRoles: "Όλοι οι ρόλοι",
  noMatchingUsers: "Δεν βρέθηκαν αντίστοιχοι χρήστες",
  noUsersFound: "Δεν βρέθηκαν χρήστες",
  createNewUser: "Δημιουργία νέου χρήστη",
  newPasswordOptional: "Νέος κωδικός (προαιρετικό)",
  leaveBlankNoChange: "Αφήστε κενό για να διατηρήσετε τον τρέχοντα κωδικό",
  confirmUserDeletion: "Επιβεβαίωση διαγραφής χρήστη",
  areYouSureDeleteUser: "Είστε σίγουροι ότι θέλετε να διαγράψετε τον {{name}};",
  thisActionCannotBeUndone: "Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",

  // Statistics page missing translations
  errorFetchingStats: "Σφάλμα κατά την ανάκτηση στατιστικών",
  noDataToExport: "Δεν υπάρχουν δεδομένα προς εξαγωγή",
  csvExportedSuccessfully: "Το CSV εξήχθη επιτυχώς",
  statisticsAndReports: "Στατιστικά και αναφορές",
  applicationStatistics: "Στατιστικά εφαρμογής",
  printPage: "Εκτύπωση σελίδας",
  reportType: "Τύπος αναφοράς",
  allExcavators: "Όλα τα μηχανήματα",
  allTypes: "Όλοι οι τύποι",
  reportStatusDistribution: "Κατανομή κατάστασης αναφορών",
  machineSpecificStatsComingSoon: "Στατιστικά συγκεκριμένων μηχανημάτων έρχονται σύντομα",
  personnelSpecificStatsComingSoon: "Στατιστικά προσωπικού έρχονται σύντομα",
  betriebstagebuchTotal: "Σύνολο ημερολογίων",

  // Batch generation missing translations
  configurationTemplate: "Πρότυπο διαμόρφωσης",
  dateRangeForGeneration: "Περίοδος για δημιουργία",
  weekendsAreExcludedInfo: "Τα Σαββατοκύριακα (Σάββατο και Κυριακή) εξαιρούνται αυτόματα",
  dailyEntryTemplate: "Πρότυπο ημερήσιας καταχώρησης",
  defaultConveyorChecks: "Προεπιλεγμένοι έλεγχοι μεταφορέων",
  allConveyorsWillBeAddedInfo: "Όλοι οι μεταφορείς θα προστεθούν σε κάθε καταχώρηση",
  signatureRequiredForGeneration: "Απαιτείται υπογραφή για δημιουργία",
  noWorkdaysInRange: "Δεν υπάρχουν εργάσιμες ημέρες στο εύρος",
  adminsOnlyCanAccessBatch: "Μόνο οι διαχειριστές μπορούν να έχουν πρόσβαση στη μαζική δημιουργία",

  // Footer missing translations
  // Additional component translations
  maker: "Κατασκευαστής",
  selectFile: "Επιλογή αρχείου",
  removeImage: "Αφαίρεση εικόνας",
};

export default translations;
